export default __webpack_public_path__ + "static/media/google.665b288f.svg";